import { AppBar, Toolbar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import "./../../App.css";
import { UserInfo } from "./UserInfo";
import { SystemStatus } from "./SystemStatus";
import lightLogo from "../../assets/img/EFK-full-logo-light.png";
import darkLogo from "../../assets/img/EFK-full-logo-dark.png";
import { useSelector } from "react-redux";

export function Header() {
  const theme = useSelector((state: any) => state.settings.theme);

  return (
    <AppBar
      position="relative"
      color="inherit"
      style={{ display: "flex" }}
      enableColorOnDark
      elevation={0}
      variant="outlined"
    >
      <Toolbar disableGutters>
        <Box
          sx={{
            flexGrow: 1,
            textAlign: "right",
            display: "flex",
            flexDirection: "row",
            marginRight: "1rem",
          }}
        >
          <Box
            component="img"
            sx={{
              alignSelf: "center",
              width: "250px",
              height: "63px",
            }}
            alt="efk-logo"
            src={theme === "dark" ? darkLogo : lightLogo}
          />
          <Box sx={{ flexGrow: 10, ml: "10%" }}>
            <SystemStatus />
          </Box>
          <Typography
            variant="body1"
            component="div"
            sx={{ flexShrink: 1, flexGrow: 1 }}
          >
            <UserInfo />
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
